import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../../NavLinks';

import validate from './TeamEntryHQSelectOrgUnitValidation';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetEntryInfoDropdown from '../../../../components/dropdowns/UseOmeMeetEntryInfoDropdown';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetTeamEntryData from '../../../../state/omeMeetTeamEntry/UseOmeMeetTeamEntryData';
import useOrgUnitOmeMeetEntryData from '../../../../state/orgUnitOmeMeetEntry/UseOrgUnitOmeMeetEntryData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';

import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const useTeamEntryHQOrgUnitSelection = () => {
    const navigate = useNavigate();
    const { omeMeetState, clearOmeMeetArrayData, setOmeMeetState } = useOmeMeetData();
    const { omeMeetEntryInfoState } = useOmeMeetEntryInfoDropdown();
    const { omeMeetOrgUnitEntryState, postOmeMeetOrgUnitEntry, clearOmeMeetOrgUnitEntryObjData,
        clearOmeMeetOrgUnitEntryArrayData } = useOmeMeetOrgUnitEntryData();
    const { omeMeetOrgUnitEntryInfoState, getOmeMeetOrgUnitEntryInfo, clearOmeMeetOrgUnitEntryInfoObjData } = useOmeMeetOrgUnitEntryInfoData();
    const { resetOmeMeetTeamEntryState } = useOmeMeetTeamEntryData();
    const { clearArrayData } = usePersonOrgRoleData();
    const { orgUnitOmeMeetEntryState } = useOrgUnitOmeMeetEntryData();
    const { searchMeetState, setSearchMeetState } = useSearchMeetData();
    const [state, setState] = useState({ radioButtonList: [], showRadioButtonList: false, tryGetOmeMeetOrgUnitEntryInfo: false, tryRedirect: false });
    const { handleSubmit, formState, errorState, onValueTextPairChanged, onFormValueChanged, setFormState
    } = UseForm(getInitialFormState, submitFormCallback, validate);

    const onBackClicked = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        clearOmeMeetOrgUnitEntryObjData();
        clearOmeMeetOrgUnitEntryArrayData();
        clearOmeMeetOrgUnitEntryInfoObjData();
        clearOmeMeetArrayData();
        resetOmeMeetTeamEntryState();
        clearArrayData();

        navigate(NavLinks.MEET_ENTRY_TEAM);
    }

    function submitFormCallback() {
        handlePost();
    }

    function handlePost() {
        postOmeMeetOrgUnitEntry(omeMeetState.objData.omeMeetId, formState.omeMeetEntryId, createOmeMeetOrgUnitEntryObject());
        setOmeMeetState({ ...omeMeetState, route: 'meet' });
        setState({ ...state, tryGetOmeMeetOrgUnitEntryInfo: true });
    }

    function createOmeMeetOrgUnitEntryObject() {
        const todaysDateTime = new Date();
        return {
            omeMeetId: omeMeetState.objData.omeMeetId,
            omeMeetEntryId: formState.omeMeetEntryId,
            orgUnitId: formState.orgUnit[0]?.id,
            orgUnitEntryDatetime: todaysDateTime,
            orgUnitSubmissionDatetime: null,
            orgUnitRegistrationStartDate: null,
            orgUnitRegistrationEndDate: null,
            status: formState.orgUnit[0]?.name === 'Unattached' ? Constants.WORKFLOW_STATUS_UNATTACHED : Constants.WORKFLOW_STATUS_IN_PROGRESS,
            orgUnitAthleteRegistrationAllowed: formState.orgUnit[0]?.name === 'Unattached' ? true : null
        }
    }

    useEffect(() => {
        if (omeMeetEntryInfoState.isArrayLoaded === true && omeMeetEntryInfoState.omeMeetId === omeMeetState.objData.omeMeetId
            && omeMeetEntryInfoState.options?.length === 2) {
            setFormState({
                ...formState,
                omeMeetEntryId: omeMeetEntryInfoState.options[1]?.id,
                omeMeetEntryName: omeMeetEntryInfoState.options[1]?.name,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetEntryInfoState, omeMeetState.objData.omeMeetId])

    useEffect(() => {
        if (state.tryGetOmeMeetOrgUnitEntryInfo === true && omeMeetOrgUnitEntryState.isSaving === false &&
            omeMeetOrgUnitEntryState.isSaved === true && omeMeetState.route === 'meet') {
            getOmeMeetOrgUnitEntryInfo(omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId);
            setState({ ...state, tryGetOmeMeetOrgUnitEntryInfo: false, tryRedirect: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetOrgUnitEntryState, state.tryGetOmeMeetOrgUnitEntryInfo, omeMeetState.route])

    useEffect(() => {
        if (state.tryRedirect === true && omeMeetOrgUnitEntryState.isSaving === false &&
            omeMeetOrgUnitEntryState.isSaved === true && omeMeetOrgUnitEntryInfoState.isObjLoaded === true &&
            omeMeetOrgUnitEntryInfoState.objData?.omeMeetOrgUnitEntryId === omeMeetOrgUnitEntryState.objData?.omeMeetOrgUnitEntryId
            && omeMeetState.route === 'meet') {
            setSearchMeetState({ ...searchMeetState, showMeetHeader: false });
            navigate(NavLinks.OU_ADMIN_MEET_INFO, { state: { isReadOnly: false } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, state.tryRedirect, omeMeetState.route])

    function getInitialFormState() {
        return {
            omeMeetEntryId: Constants.DEFAULT_ID,
            omeMeetEntryName: '--',
            orgUnit: []
        };
    }

    return {
        state,
        handleSubmit,
        formState,
        errorState,
        onValueTextPairChanged,
        onFormValueChanged,
        omeMeetState,
        omeMeetEntryInfoState,
        omeMeetOrgUnitEntryState,
        omeMeetOrgUnitEntryInfoState,
        orgUnitOmeMeetEntryState,
        onBackClicked
    };
};

export default useTeamEntryHQOrgUnitSelection;